import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { ExistingFileData } from "../../../types";
import ReadOnlyFileCard from "../ReadOnlyFileCard";
import * as uploadStyles from "../styles_vanilla.css";

interface ExistingFilesSectionProps {
  existingFiles: ExistingFileData[];
}

const ExistingFilesSection: React.FC<ExistingFilesSectionProps> = ({ existingFiles }) => {
  return (
    <Flex className={uploadStyles.fileConfigSection} flexDirection="column" gap={Sizes.MD}>
      <Flex className={uploadStyles.fileConfigHeader} flexDirection="column" gap={Sizes.XS}>
        <Flex alignItems="center" gap={Sizes.SM}>
          <Icon type="file-alt" size="small" color={Colors.Success600} />
          <Text variant="strong-lg" color={Colors.Neutral900}>
            Uploaded Files
          </Text>
        </Flex>
        <Text variant="regular-md" className={uploadStyles.subtitleText}>
          The following files have already been uploaded for this job. No additional files can
          be uploaded.
        </Text>
        <Text variant="regular-sm" className={uploadStyles.fileCount}>
          {existingFiles.length} file{existingFiles.length !== 1 ? "s" : ""} uploaded
        </Text>
      </Flex>

      <Flex flexDirection="column" gap={Sizes.SM}>
        {existingFiles.map((fileData) => (
          <ReadOnlyFileCard
            key={`${fileData.toolType}-${fileData.fileName}`}
            fileData={fileData}
          />
        ))}
      </Flex>

      <Flex className={uploadStyles.infoMessage} alignItems="center" gap={Sizes.SM}>
        <Icon type="info-circle" size="small" color={Colors.Primary600} />
        <Text variant="regular-sm" color={Colors.Neutral700}>
          Files have already been uploaded for this job. To make changes, please start a new
          import job.
        </Text>
      </Flex>
    </Flex>
  );
};

export default ExistingFilesSection;
